import {
  LegalClientFirstHeadEntity,
  LegalClientLegalHeadEntity,
} from 'api/types/entity';
import { useTranslation } from 'libs/i18n';
import { DialogStateProps } from 'libs/ui';
import { AddDialogForm } from 'modules/client/common/components';

import { LegalClientAddFirstHeadSections } from '../components';
import { useLegalClientAddFirstHead } from '../hooks';

interface Props extends DialogStateProps {
  legalClientLegalHead: LegalClientLegalHeadEntity;
  onSuccess: (legalClientFirstHead: LegalClientFirstHeadEntity) => void;
}

export const LegalClientAddFirstHeadDialogFeature = ({
  legalClientLegalHead,
  isOpen,
  onClose,
  onSuccess,
}: Props) => {
  const {
    countries,
    countriesLoading,
    initialValues,
    validationSchema,
    formError,
    submitLoading,
    onSubmit,
  } = useLegalClientAddFirstHead(legalClientLegalHead, onSuccess);

  const { t } = useTranslation();

  return (
    <AddDialogForm
      initialErrors={formError}
      initialValues={initialValues}
      isOpen={isOpen}
      submitLoading={submitLoading}
      title={t('client.legal.legalClientFirstHead.addDialog.title')}
      validationSchema={validationSchema}
      onClose={onClose}
      onSubmit={onSubmit}
    >
      <LegalClientAddFirstHeadSections
        countries={countries ?? []}
        countriesLoading={countriesLoading}
      />
    </AddDialogForm>
  );
};
